<template>
  <span class="text-EXPONDO-red flex items-center gap-1 text-sm">
    <span class="iconify svg--clock text-EXPONDO-red text-base m-0.25" />
    {{ $t('limited-time-offer-disclaimer') }}
  </span>
</template>
<script lang="ts">

export default defineComponent({
  name: 'LimitedTimeOffer',
});

</script>
